module.exports = __webpack_public_path__ + "static/img/T7404.5b3b2342.png";